import { Profile } from "../../../../api/api-profile";
import { Session } from "../../../../api/api-user";
import * as types from "../constants/action-types";

import { fetchEntitlements } from "./entitlements";
import { fetchMessageCount, fetchManagedAccount, fetchBankStatus } from "./nav";
import { fetchUserNux } from "./nux";

function resetAuth() {
  return {
    type: types.RESET_ENV,
  };
}

function receiveAccessToken(accessToken) {
  return {
    type: types.RECEIVE_ACCESS_TOKEN,
    accessToken,
  };
}

function accessTokenFailure() {
  return {
    type: types.ACCESS_TOKEN_FAILURE,
  };
}

function receiveGAClientId(gaClientId) {
  return {
    type: types.RECEIVE_GA_CLIENT_ID,
    gaClientId,
  };
}

function profileRequest() {
  return {
    type: types.PROFILE_REQUEST,
  };
}

function profileSuccess(profile) {
  if (global.PSSessions) {
    PSSessions.Cookies.set("PSUser", profile.SSOid);
  }
  return {
    type: types.PROFILE_SUCCESS,
    profile,
  };
}

function profileFailure() {
  return {
    type: types.PROFILE_FAILURE,
  };
}

function preProfileSuccess(accessToken, profile) {
  return (dispatch) => {
    const gaClientId = analyticsIntegrations.getGoogleAnalyticsID();

    // Profile has been received, dispatch various
    // actions around other `auth` level state.
    dispatch(profileSuccess(profile));
    dispatch(receiveGAClientId(gaClientId));
    dispatch(fetchMessageCount(accessToken, profile));
    dispatch(fetchManagedAccount(accessToken, profile));
    dispatch(fetchEntitlements(accessToken, profile));
    dispatch(fetchUserNux("trigger=page-load"));
    if (profile.is_host && profile.sk_completed) {
      dispatch(fetchBankStatus(accessToken, profile));
    }
  };
}

export function fetchProfile(accessToken, refreshProfile) {
  return (dispatch) => {
    const profilePath = "/v1/profiles/me";
    // Dispatch action that profile is being requested.
    dispatch(profileRequest());
    // Request profile.
    Profile.read(profilePath, accessToken, (response) => {
      // No profile.
      if (response.error) {
        return dispatch(profileFailure());
      }

      // Successful profile.
      if (refreshProfile) {
        return dispatch(profileSuccess(response));
      }
      return dispatch(preProfileSuccess(accessToken, response));
    });
  };
}

export const fetchTransactStatus = (ssoId, accessToken) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({ type: types.PROFILE_TRANSACT_REQUEST });

      Profile.read(
        `/v1/profiles/${ssoId}/status/transact`,
        accessToken,
        (response) => {
          if (200 === response.statusCode) {
            dispatch({
              type: types.PROFILE_TRANSACT_SUCCESS,
              transactStatus: response,
            });

            return resolve(response);
          }

          dispatch(dispatch({ type: types.PROFILE_TRANSACT_FAILURE }));
          return reject(response);
        },
      );
    });
  };
};

export function updateProfile200(profile) {
  return (dispatch) => {
    return dispatch({
      type: types.PROFILE_UPDATE_SUCCESS,
      profile,
    });
  };
}

export function logoutUser() {
  return (dispatch, getState) => {
    const { auth } = getState();
    const { accessToken } = auth;

    Session.destroy(accessToken, (response) => {
      const { error } = response;
      if (error && -1 === error.indexOf("Invalid Access Token")) {
        // TODO: Handle this gracefully
      } else {
        if (global.PSSessions) {
          PSSessions.eH.logout();
        }
        analyticsIntegrations.accountLogout();

        dispatch(resetAuth());
      }
    });
  };
}

/**
 * Main `auth` level action dispatcher
 * (accessToken, profile, gaclientid)
 *
 * @function
 * @name initAuth
 */
export function initAuth(accessToken) {
  return (dispatch, getState) => {
    const { auth } = getState();
    const token = auth.accessToken || accessToken;

    if (!token) {
      // Not all pages require authentication,
      // so we simply dispatch this action to track the state.
      // See router for authenicated routes.
      return dispatch(accessTokenFailure());
    }

    dispatch(receiveAccessToken(token));
    return dispatch(fetchProfile(token));
  };
}
